/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckOutlined = createIcon({
  name: 'icon-check-outlined',
  content: '<path d="M395.708774 781.222153l495.623647-495.687368 45.050902 45.050903-495.623647 495.623646z"/><path d="M169.880772 465.738395l315.420037 315.420037-45.114624 45.050902-315.420037-315.420037z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCheckOutlined;
